
import { Component, Vue, Watch } from 'vue-property-decorator';
import { extend, ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', required);

@Component({
  name: 'checkout-payment-detail',
  components: {
    CheckoutPaymentMethodsDefault: require('./../payment/methods/Default.vue').default,
    ValidationProvider,
  },
})
export default class extends Vue {
  private get returnedFromBuckaroo(): boolean {
    return document.referrer.includes('buckaroo');
  }

  private get paymentMethods(): Array<object> {
    return this.$store.getters['CheckoutPayment/paymentMethods'];
  }

  private get selectedPaymentMethod(): object | string {
    return this.$store.getters['CheckoutPayment/selectedPaymentMethod'];
  }

  private get loadingPaymentData(): boolean {
    return this.$store.getters['CheckoutPayment/loadingPaymentData'];
  }

  @Watch('selectedPaymentMethod', { deep: true })
  async handleSelectedPaymentMethod(nv, ov) {
    if (nv && nv !== ov) {
      await this.$store.dispatch('CheckoutPayment/setPaymentMethod', nv);
    }
  }

  private get shippingMethod(): object | null {
    return this.$store.getters['CheckoutShipping/shippingMethod'];
  }

  private get currentStep(): number {
    return this.$store.getters['CheckoutGlobal/currentStep'];
  }

  private async collectPaymentMethods(): Promise<any> {
    // Only collect payment methods if we have a shipping method selected
    if (!this.shippingMethod || Object.keys(this.shippingMethod).length === 0) {
      console.warn('Cannot collect payment methods: no shipping method selected yet');
      return;
    }

    try {
      await this.$store.dispatch('CheckoutPayment/collectPaymentMethods');
      if (this.selectedPaymentMethod.hasOwnProperty('code')) {
        await this.$store.dispatch('CheckoutPayment/setSelectedPaymentMethod', this.selectedPaymentMethod);
      }
    } catch (error) {
      console.error('Failed to collect payment methods:', error);
    }
  }

  private getPaymentMethodComponent(methodCode): string {
    switch (methodCode) {
      default:
        return 'checkout-payment-methods-default';
    }
  }

  @Watch('currentStep')
  async handleStepChange(newStep: number) {
    // When user navigates to step 3, ensure we have payment methods
    if (newStep === 3) {
      await this.collectPaymentMethods();
    }
  }

  @Watch('shippingMethod', { deep: true })
  async handleShippingMethodChange(newMethod: object, oldMethod: object) {
    // If shipping method changes and we're on step 3, refresh payment methods
    if (this.currentStep === 3 && newMethod && (!oldMethod || newMethod['method_code'] !== oldMethod['method_code'])) {
      await this.collectPaymentMethods();
    }
  }

  private async created(): Promise<void> {
    // Initial load only if we're already on step 3
    if (this.currentStep === 3) {
      await this.collectPaymentMethods();
    }
  }
}
